import unit from 'plugins/i18n/entity/unit.de.ts'

const document = {
	name: 'Dokument | Dokumente',
	icon: 'fa-fw fas fa-file',
	fields: {
		ts: 'Datum',
		document_type: {
			name: 'Typ',
		},
		document_container: {
			units: {
				...unit.fields,
			},
		},
		file_notes: 'Name',
		posting_year: 'Buchungsjahr',
	},
}

export default document
